









































































































































import { Component, Vue } from 'vue-property-decorator'
import {getLocalItem} from '@/utils'
import EnergySaving from './components/EnergySaving.vue'
import ConsumptionSanking from './components/ConsumptionSanking.vue'
import Consumption from './components/Consumption.vue'
import Map from './components/map/index.vue'
import ConsumptionStructure from './components/ConsumptionStructure.vue'
import EnergyConsumption from './components/EnergyConsumption.vue'
import IndustrialOutput from './components/IndustrialOutput.vue'

@Component({
  name: 'Bigscreen',
  components: {
    EnergySaving, //节能监察
    ConsumptionSanking,
    Consumption,
    Map,
    ConsumptionStructure,
    EnergyConsumption,
    IndustrialOutput,
  },
})
export default class Bigscreen extends Vue {
    private client:any =getLocalItem('client')
  Reload() {
    (this.$refs['Map'] as any).nomole({}),
     this.cllbanck({   regionCode: this.client.custRegionCode,
        regionName:this.client.regionName })
  }
    private areaCode :string = getLocalItem('client').custRegionCode
    private screenWidth:any= 1920
    private screenHeight:any= 1080
    private widthRate:any= 1
    private heightRata:any=1
    private allWidth:any= 0
    private height:any= null
    private width:any= null
    private id:any= ''

    private area :string = getLocalItem('client').regionName
    private Timefun() {
    const now = new Date()
    let yy = now.getFullYear() //年
    const mm = now.getMonth() + 1 //月
    // const dd = now.getDate() //日
    // let hh = now.getHours() //时
    // let ii = now.getMinutes() //分
    // let ss = now.getSeconds() //秒
    if (mm == 1) {
      yy--
    }

    var clock = ''
    clock +=
      yy +
      '年 ' +
      '1月' +
      (mm == 1 ? '-12月' : mm == 2 ? '' : '-' + (mm - 1) + '月')
    return clock
  }

  cllbanck(e: any) {
        this.area = e.regionName
        this.areaCode=e.regionCode
  }
      /**
     * 入参
     * @param id 自适应Box Id
     * @param width 自适应原始宽度，默认1920
     * @param height 自适应原始高度，默认1080
     */
    FullContainer(id:any, width = 1920, height = 1080) {
        const dom=document.getElementById(id) as HTMLInputElement
        dom.setAttribute('style', `overflow: hidden;transform-origin: left top;`)
        dom.style.width = `${width}px`
        dom.style.height = `${height}px`
        this.id = id
        this.width = width
        this.height = height
        this.allWidth = width
        this.debounce(100, this.initWH(id))
        this.bindDomResizeCallback()
    }

    initWH(id:any, resize = true) {
      return new Promise((resolve) => {
        const dom = document.getElementById(id)

        const width = dom ? dom.clientWidth : 0
        const height = dom ? dom.clientHeight : 0

        // if (!dom) {
        //   console.warn(
        //     'DataV: Failed to get dom node, component rendering may be abnormal!'
        //   )
        // } else if (!width || !height) {
        //   console.warn(
        //     'DataV: Component width or height is 0px, rendering abnormality may occur!'
        //   )
        // }

        if (resize) this.onResize()
        resolve('')
      })
    }

    onResize() {
      const { allWidth, id } = this
        const dom=document.getElementById(id) as HTMLInputElement
      dom.style.transform = `scale(${
        document.body.clientWidth / allWidth
      },${document.body.clientHeight / this.height})`
    }

    bindDomResizeCallback() {
      window.addEventListener('resize', () => {
        this.debounce(100, this.initWH(this.id))
      })
    }

    debounce(delay:any, callback:any) {
      let lastTime:any=''

      return function (this:any) {
        clearTimeout(lastTime)

        const [that, args] = [this, arguments]
        lastTime = setTimeout(() => {
          callback.apply(that, args)
        }, delay)
      }
    }
    mounted() {
        this.FullContainer('home')
    }
}
